import { ApplicationBracesOutlineIcon } from './ApplicationBracesOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 3727A772-B282-4785-B291-A7C7EBCB25A8
 * name application-braces-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-braces-outline.svg
 * tags
 * - Developer / Languages 
 */
export const IframeBracesOutlineIcon = ApplicationBracesOutlineIcon;
export default IframeBracesOutlineIcon